import { useSelector } from 'react-redux';
import { formatNotificationMessage, hasNotificationMessage } from 'utils/notificationMessage';

/**
 * Subscribes to global toast notification state (AppNotification).
 * Do not use hasError/hasSuccess for table empty states — any saga action (invite, delete, etc.)
 * sets the same failedMsg and will mislabel unrelated pages as "Request failed".
 */
export function useNotificationMessages() {
  const successMsg = useSelector((state) => state.getIn(['notification', 'successMsg']));
  const failedMsg = useSelector((state) => state.getIn(['notification', 'failedMsg']));

  return {
    successText: formatNotificationMessage(successMsg),
    failedText: formatNotificationMessage(failedMsg),
    hasSuccess: hasNotificationMessage(successMsg),
    hasError: hasNotificationMessage(failedMsg),
  };
}
